<template>
    <div class="flex flex-column">
        <label v-if="showLabel" class="mb-2" :for="label"> {{ label }}:</label>
        <VueTreeSelect
            :id="label"
            class="p-multiselect p-component"
            :class="{ 'p-invalid': props.errorMessage }"
            v-model="selectedTreeValue"
            :options="optionsTree"
            :value-consists-of="props.valueConsist"
            :placeholder="vueTreeSelectPlaceholderLabel(label)"
            :multiple="props.multiple"
            :limit="props.limit"
        />
        <small class="p-invalid" v-if="props.errorMessage">{{ props.errorMessage }}</small>
    </div>
</template>
<script setup>

/*
Please note:
The component VueTreeSelect is not able to react to v-model changes: if it changes no internal changes are fired.
Change the :key to force Vue to consider it a new component.
E.g.
<custom-vue-tree-select :key="my_key" v-model="my_model" [...] />
 */

import { ref, defineProps, defineEmits, watch, onMounted } from 'vue';
import { vueTreeSelectPlaceholderLabel } from '../../utilities/index.js';

const emit = defineEmits(['update:modelValue', 'tree-select-changed']);

const props = defineProps({
    modelValue: {
        type: [Number, String, Array],
    },
    label: {
        type: String,
    },
    optionsTree: {
        type: Array,
    },
    errorMessage: {
        type: String,
    },
    showLabel: {
        type: Boolean,
        default: false,
    },
    valueConsist: {
        type: String,
        default: 'BRANCH_PRIORITY',
    },
    multiple: {
        type: Boolean,
        default: false,
    },
    limit: {
        type: Number,
        default: Infinity,
    },
});
const selectedTreeValue = ref(null);

onMounted(() => {
    if (props.modelValue) {
        selectedTreeValue.value = props.modelValue;
    }
});

watch(selectedTreeValue, () => {
    emit('tree-select-changed', selectedTreeValue.value);
    emit('update:modelValue', selectedTreeValue.value);
});
</script>
<style scoped>
.p-multiselect {
    border: none !important;
}

.p-breadcrumb {
    border: none;
}
::v-deep(.vue-treeselect__placeholder) {
    color: #657379 !important;
}
</style>
